import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import InteracMoneyRequestTransactionInfo from './InteracMoneyRequestTransactionInfo';
import useFetchInteracMoneyRequestTransaction from '../../../../hooks/useApi/useFetchInteracMoneyRequestTransaction';

type TransactionProps = {
  TransactionID: string;
  Notes?: string;
};
type FC = FunctionComponent<TransactionProps>;

const InteracMoneyRequestTransactionContainer: FC = (props: TransactionProps) => {
  const { TransactionID, Notes } = props;
  const [InteracMoneyRequest, getInteracMoneyRequestTransaction] = useFetchInteracMoneyRequestTransaction({
    bearer: '',
  });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.InteracTransactionResponse>();

  useEffect(() => {
    getInteracMoneyRequestTransaction(TransactionID);
  }, [currentTransactionId]);

  useEffect(() => {
    if (InteracMoneyRequest) {
      setTransaction(InteracMoneyRequest);
    }
  }, [InteracMoneyRequest]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return (
    <div>{transaction && <InteracMoneyRequestTransactionInfo transaction={transaction} Notes={Notes || ''} />}</div>
  );
};

export default InteracMoneyRequestTransactionContainer;
